import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose, DialogFooter } from "../../@/components/ui/dialog";
import { Button } from "../../@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../../@/components/ui/select";
import { Spinner } from "@/components/spinner";
import axios from "axios";
import { api_endpoint } from "@/constants/constant";
import { toast } from "sonner";
import { useAuth } from "@clerk/clerk-react";
import { ClipLoader } from "react-spinners";

export default function AssignRoleDialog({ user, open, onOpenChange, onAssigned }) {
    const [roles, setRoles] = useState([])
    const [selectedRole, setSelectedRole] = useState("")
    const [loading, setLoading] = useState(false)
    const [assigning, setAssigning] = useState(false)
    const { getToken } = useAuth();

    const fetchRoles = async () => {
        setLoading(true)
        setRoles([])
        setSelectedRole("")
        try {
            const token = await getToken()
            if (!token) return;
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }

            const response = await axios.get(api_endpoint + "/user/roles", reqConfig)
            console.log("Fetched roles:", response.data)
            setRoles(response.data?.roles || [])

        } catch (error) {
            console.error("Error fetching roles:", error)
            toast.error("Failed to fetch roles. Please try again.")
            
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (open) {
            fetchRoles()
        }
    }, [open, getToken])


    const handleAssignRole = async () => {
        if (!selectedRole) {
            toast.error("Please select a role to assign.")
            return
        }
        setAssigning(true)
        try {
            const token = await getToken()
            if (!token) return;
            const reqConfig = {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            }

            const response = await axios.post(api_endpoint + `/user/users/${user.id}/roles/${selectedRole}`, {}, reqConfig)
            console.log("Role assigned:", response.data)
            toast.success("Role assigned successfully.")
            onAssigned?.()
            onOpenChange(false)
        } catch (error) {
            console.error("Error assigning role:", error)
            toast.error("Failed to assign role. Please try again.")
        } finally {
            setAssigning(false)
        }
    }

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="h-auto">
                <DialogHeader>
                    <DialogTitle className="font-heading text-xl text-(--neutral-900)">Assign Role</DialogTitle>
                    <DialogDescription className="font-body text-(--neutral-700)">
                        Assign a new role to <span className="font-semibold">{user?.name || user?.username}</span>
                    </DialogDescription>
                </DialogHeader>
                {loading ? (
                    <div className="flex justify-center py-8"><Spinner /></div>
                ) : (
                    <div className="space-y-4">
                        <Select value={selectedRole} onValueChange={setSelectedRole}>
                            <SelectTrigger className="w-full">
                                <SelectValue placeholder="Select a role" />
                            </SelectTrigger>
                            <SelectContent>
                                {roles.map(role => (
                                    <SelectItem key={role.id} value={role.id.toString()}>
                                        {role.title}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                        <DialogFooter className="">
                            <DialogClose asChild>
                                <Button 
                                    variant="outline" 
                                    disabled={assigning}
                                    className=""
                                    >
                                        Cancel
                                        </Button>
                            </DialogClose>
                            <Button 
                                variant=""
                                onClick={handleAssignRole} 
                                disabled={assigning || !selectedRole} 
                                className="">
                                {assigning ? <ClipLoader size={18} color="#fff"/> : "Assign"}
                            </Button>
                        </DialogFooter>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    )
}